"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.strong = exports.buttonGroup = exports.panel = exports.panelBlock = exports.iconSpan = exports.icon = exports.buttonLinkTo = exports.linkTo = exports.messageBlock = exports.strToMinutes = exports.moneyField = exports.minutesToString = exports.minutesToUnit = exports.withVAT = exports.money = exports.moneyAdd = exports.boolProperty = exports.ifTrue = exports.ifAny = exports.tags = exports.tag = exports.small = exports.moneyToString = exports.numberMoneyToString = exports.eachSlice = exports.dig = exports.hourMinutes = exports.padded = exports.copiable = exports.promised = exports.capsule = exports.capsuleGroup = exports.phoneto = exports.mailto = exports.formatTime = exports.button = exports.getParentByClass = exports.kpi = exports.inputWithIcon = exports.card = exports.getOffset = exports.buttons = exports.identity = exports.renderProperties = exports.range = exports.empty = exports.getMonthFr = exports.MONTHS_SHORT = exports.MONTHS = exports.renderMoney = void 0;
exports.transformMoneyInput = exports.fastIntersection = exports.isMobile = exports.responsiveValues = exports.level = exports.renderMoneyInput = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../app");
const copier_1 = require("./copier");
const moment = require("moment");
function renderMoney(x) {
    if (typeof x === "number") {
        if (x == 0)
            return "-";
        x = x.toFixed(2);
    }
    return x.replace(/\d(?=(\d{3})+\.)/g, '$& ');
}
exports.renderMoney = renderMoney;
exports.MONTHS = {
    "1": "Janvier",
    "2": "Février",
    "3": "Mars",
    "4": "Avril",
    "5": "Mai",
    "6": "Juin",
    "7": "Juillet",
    "8": "Août",
    "9": "Septembre",
    "10": "Octobre",
    "11": "Novembre",
    "12": "Décembre",
};
exports.MONTHS_SHORT = {
    "1": "Jan",
    "2": "Fév",
    "3": "Mar",
    "4": "Avr",
    "5": "Mai",
    "6": "Jun",
    "7": "Jul",
    "8": "Aoû",
    "9": "Sep",
    "10": "Oct",
    "11": "Nov",
    "12": "Déc",
};
// Return the month name in french
function getMonthFr(x, short = false) {
    return (short ? exports.MONTHS_SHORT : exports.MONTHS)[`${x}`];
}
exports.getMonthFr = getMonthFr;
function empty(comp = undefined, text = "<vide>") {
    if (comp && !(comp === "" || (Object.prototype.hasOwnProperty.call(comp, "length") && comp.length == 0)))
        return comp;
    return (0, mithril_1.default)("span", { class: "empty" }, text);
}
exports.empty = empty;
function range(start, end, step = 1) {
    let o = new Array();
    o.length = Math.ceil((end - start) / step);
    for (let i = start; i <= end; i += step) {
        o.push(i);
    }
    return o;
}
exports.range = range;
function renderProperties(pair) {
    let out = [];
    for (let label in pair) {
        out.push((0, mithril_1.default)("dt", label));
        let toRender;
        switch (typeof (pair[label])) {
            case "boolean":
                toRender = boolProperty(pair[label]);
                break;
            default:
                toRender = pair[label];
        }
        out.push((0, mithril_1.default)("dd", (pair[label] !== undefined ? toRender : empty())));
    }
    return (0, mithril_1.default)("dl", out);
}
exports.renderProperties = renderProperties;
// Identity function. Take x in input and return x. useful for placeholder to transformation
// functions
function identity(x) { return x; }
exports.identity = identity;
;
function buttons(...children) {
    return (0, mithril_1.default)("p", { class: "buttons" }, ...children);
}
exports.buttons = buttons;
function getOffset(el) {
    let _x = 0;
    let _y = 0;
    while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
        _x += el.offsetLeft - el.scrollLeft;
        _y += el.offsetTop - el.scrollTop;
        el = el.offsetParent;
    }
    return { top: _y, left: _x };
}
exports.getOffset = getOffset;
function card(title, content) {
    return (0, mithril_1.default)(".card", (0, mithril_1.default)(".card-content.content", ifTrue(title, [
        (0, mithril_1.default)("h3", title),
        (0, mithril_1.default)("hr"),
    ]), content));
}
exports.card = card;
function inputWithIcon(icon, opts) {
    return (0, mithril_1.default)(".field", (0, mithril_1.default)("p.control.has-icons-left", (0, mithril_1.default)("input.input", Object.assign({}, opts)), iconSpan(icon, "is-left is-small")));
}
exports.inputWithIcon = inputWithIcon;
function kpi(value, label, altValue) {
    return (0, mithril_1.default)(".card", (0, mithril_1.default)(".card-content.kpi", (0, mithril_1.default)("strong.kpi-value", value), (0, mithril_1.default)(".kpi-label", label), (0, mithril_1.default)(".kpi-alt", altValue || mithril_1.default.trust("&nbsp;"))));
}
exports.kpi = kpi;
function getParentByClass(className, el) {
    if (el.classList.contains(className))
        return el;
    const parent = el.parentElement;
    if (parent)
        return getParentByClass(className, parent);
    return undefined;
}
exports.getParentByClass = getParentByClass;
function button(label, options) {
    return (0, mithril_1.default)("button", { class: `button ${options.class}`, onclick: options.onclick }, label);
}
exports.button = button;
function formatTime(s, time = true, seconds = false) {
    let pattern = time ?
        (seconds ? 'DD/MM/YY HH:mm:ss' : 'DD/MM/YY HH:mm') : 'DD/MM/YY';
    if (s) {
        if (typeof s == "string") {
            return moment(s).format(pattern);
        }
        else {
            return s.format(pattern);
        }
    }
    else {
        return empty();
    }
}
exports.formatTime = formatTime;
function mailto(email, label) {
    label = label || email;
    return (0, mithril_1.default)("a", { href: `mailto:${email}`, target: "_blank" }, label);
}
exports.mailto = mailto;
function phoneto(phone) {
    if (phone === undefined || phone === "")
        return "";
    phone = phone || "";
    let formattedPhone = phone.replace(/^\\+33/, "0033")
        .split(/([0-9]{2})/)
        .filter(x => x !== "")
        .join(" ")
        .replace(/^00 33/, "+33");
    return copiable(formattedPhone);
}
exports.phoneto = phoneto;
function capsuleGroup(...children) {
    return (0, mithril_1.default)("div", { class: "field is-grouped is-grouped-multiline" }, children.map(c => (0, mithril_1.default)("div", { class: "control" }, c)));
}
exports.capsuleGroup = capsuleGroup;
function capsule(title, content, titleColor = "is-success", color = "is-light") {
    return (0, mithril_1.default)("div", { class: "tags has-addons" }, (0, mithril_1.default)("span", { class: `tag ${titleColor}` }, title), (0, mithril_1.default)("span", { class: `tag ${color}` }, content));
}
exports.capsule = capsule;
function promised(data) {
    return new Promise(function (succ, _) {
        succ(data);
    });
}
exports.promised = promised;
function copiable(content) {
    return (0, mithril_1.default)("span", { style: "cursor: pointer;", title: "Copier dans le presse papier", class: "copiable", onclick: (evt) => {
            const self = getParentByClass("copiable", evt.target);
            if (self) {
                evt.preventDefault();
                evt.stopPropagation();
                (0, copier_1.copyToClipboard)(self.innerText);
            }
        } }, content);
}
exports.copiable = copiable;
function padded(x, paddingCount) {
    let chars = x.toString().split('');
    chars = chars.reverse();
    while (chars.length < paddingCount) {
        chars.push("0");
    }
    return chars.reverse().join("");
}
exports.padded = padded;
/** Return the Hour + Minutes display from hour and minute, which can be not padded */
function hourMinutes(hour, minute) {
    minute = minute.toString();
    hour = hour.toString();
    if (minute.length == 1) {
        minute = "0" + minute;
    }
    if (hour.length == 1) {
        hour = "0" + hour;
    }
    return [hour, minute].join("h");
}
exports.hourMinutes = hourMinutes;
/**
 * Lookup deep inside an object. Return undefined if it cannot.
 */
function dig(obj, ...args) {
    if (obj === undefined) {
        return undefined;
    }
    if (args.length == 0) {
        return obj;
    }
    let k = obj[args[0]];
    if (k !== undefined) {
        let arr = [].concat(args);
        arr.shift();
        return dig(k, ...arr);
    }
    return undefined;
}
exports.dig = dig;
const eachSlice = function (array, size, callback) {
    for (var i = 0, l = array.length; i < l; i += size) {
        callback.call(array, array.slice(i, i + size));
    }
};
exports.eachSlice = eachSlice;
function numberMoneyToString(x) {
    return (x).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$& ') + " €";
}
exports.numberMoneyToString = numberMoneyToString;
function moneyToString(x) {
    return numberMoneyToString(x.raw / 100);
}
exports.moneyToString = moneyToString;
function small(...children) {
    return (0, mithril_1.default)("small", children);
}
exports.small = small;
function tag(child, color = null, size = null) {
    let klass = 'tag';
    if (color) {
        klass += ' is-' + color;
    }
    if (size) {
        klass += ' is-' + size;
    }
    return (0, mithril_1.default)("span", { class: klass }, child);
}
exports.tag = tag;
function tags(tags, color = null, size = null) {
    let klass = 'tags';
    if (size) {
        klass += ' are-' + size;
    }
    let subklass = 'tag';
    if (color) {
        subklass += ' is-' + color;
    }
    return (0, mithril_1.default)("div", { class: klass }, tags.map(t => {
        return (0, mithril_1.default)("span", { class: subklass }, t);
    }));
}
exports.tags = tags;
function ifAny(x, yes, no) {
    return (x.length != 0) ? yes(x) : no(x);
}
exports.ifAny = ifAny;
function ifTrue(test, value, ifFalse) {
    if (test) {
        return value;
    }
    return ifFalse;
}
exports.ifTrue = ifTrue;
function boolProperty(x) {
    return x ? tag("OUI", 'success') : tag("NON", 'danger');
}
exports.boolProperty = boolProperty;
function moneyAdd(a, b) {
    return { raw: Math.round(a.raw + b.raw), currency: a.currency };
}
exports.moneyAdd = moneyAdd;
function money(x = 0, c) {
    return { raw: x, currency: c };
}
exports.money = money;
function withVAT(x) {
    return { raw: Math.round(x.raw * (1 + app_1.App.VAT_RATE)), currency: x.currency };
}
exports.withVAT = withVAT;
function minutesToUnit(minutes) {
    return (minutes / 60).toFixed(2);
}
exports.minutesToUnit = minutesToUnit;
/** Return a string representing the time in hh:mm based on a number of minutes */
function minutesToString(minutes) {
    return hourMinutes(Math.floor(minutes / 60), Math.floor(minutes) % 60);
}
exports.minutesToString = minutesToString;
function moneyField(form, key, label) {
    return form.field(label, key, "number", {
        renderValue: (x) => { return x / 100; },
        transformValue: (x) => { return parseFloat(x) * 100; }
    });
}
exports.moneyField = moneyField;
/** Parse hour and minutes and return the value in minutes */
function strToMinutes(str) {
    if (str) {
        let x = str.split(/\:/i);
        return parseInt(x[0]) * 60 + parseInt(x[1]);
    }
    else {
        return undefined;
    }
}
exports.strToMinutes = strToMinutes;
function messageBlock(type, content) {
    return (0, mithril_1.default)("div", { class: `message is-${type}` }, (0, mithril_1.default)("div", { class: "message-body" }, content));
}
exports.messageBlock = messageBlock;
function linkTo(target, content, blank = false) {
    let _target;
    if (blank) {
        _target = "_blank";
    }
    else {
        _target = undefined;
    }
    return (0, mithril_1.default)("a", { href: target, target: _target }, content);
}
exports.linkTo = linkTo;
function buttonLinkTo(target, content, klass = "is-primary") {
    return (0, mithril_1.default)("a", { href: target, class: `button ${klass}` }, content);
}
exports.buttonLinkTo = buttonLinkTo;
function icon(name) {
    return (0, mithril_1.default)("i", { class: `fas ${name}`, "aria-hidden": "true" });
}
exports.icon = icon;
function iconSpan(name, additionalClasses = "") {
    return (0, mithril_1.default)("span", { class: `icon ${additionalClasses}` }, icon(name));
}
exports.iconSpan = iconSpan;
function panelBlock(opts) {
    let tag = opts.tag || "div";
    let icon = opts.icon;
    let out = [];
    let attrs = opts.attrs || {};
    if (icon)
        out.push((0, mithril_1.default)("span.panel-icon", (0, mithril_1.default)("i", { class: `fas ${icon}`, "aria-hidden": "true" })));
    out.push(opts.content);
    let klass = (opts.isActive ? "panel-block is-active" : "panel-block") + (opts.attrs.class || "");
    return (0, mithril_1.default)(tag, Object.assign({ class: klass }, attrs), out);
}
exports.panelBlock = panelBlock;
function panel(opts) {
    let tag = opts.tag || "nav";
    let attrs = opts.attrs || {};
    let klass = attrs.class ? `panel ${attrs.class}` : 'panel';
    let out = [];
    if (opts.title)
        out.push((0, mithril_1.default)("p.panel-heading", opts.title));
    out.push(opts.content);
    return (0, mithril_1.default)(tag, Object.assign({}, attrs, { class: klass }), out);
}
exports.panel = panel;
function buttonGroup(...args) {
    return (0, mithril_1.default)("div", { class: "field has-addons" }, args.map((x) => (0, mithril_1.default)("p", { class: "control" }, x)));
}
exports.buttonGroup = buttonGroup;
function strong(...args) {
    return (0, mithril_1.default)("strong", ...args);
}
exports.strong = strong;
function renderMoneyInput(cb) {
    return function (input) {
        if (input === undefined) {
            input = { raw: 0 };
        }
        let x = input.raw || 0;
        if (cb) {
            cb(x);
        }
        let fixedStr = (x / 100).toFixed(2);
        let autoStr = `${x / 100}`;
        return fixedStr.length > autoStr.length ? autoStr : fixedStr;
    };
}
exports.renderMoneyInput = renderMoneyInput;
function level(opts) {
    const subLevel = (struct, direction) => {
        return (0, mithril_1.default)("div", { class: `level-${direction}` }, packageItems(struct));
    };
    const packageItems = (struct) => {
        if (struct === undefined)
            return undefined;
        if (!(struct instanceof Array))
            struct = [struct];
        struct = struct.map(elm => (0, mithril_1.default)("div", { class: "level-item" }, elm));
        return struct;
    };
    return (0, mithril_1.default)("nav", Object.assign({ class: "level" }, opts.opts), subLevel(opts.left, 'left'), subLevel(opts.right, 'right'));
}
exports.level = level;
function responsiveValues(mobile, desktop) {
    if (document.body) {
        return document.body.clientWidth <= 768 ? mobile : desktop;
    }
    else {
        return mobile;
    }
}
exports.responsiveValues = responsiveValues;
function isMobile() {
    return responsiveValues(true, false);
}
exports.isMobile = isMobile;
function fastIntersection(...arrays) {
    // if we process the arrays from shortest to longest
    // then we will identify failure points faster, i.e. when
    // one item is not in all arrays
    const ordered = (arrays.length === 1
        ? arrays :
        arrays.sort((a1, a2) => a1.length - a2.length)), shortest = ordered[0], set = new Set(), // used for bookeeping, Sets are faster
    result = []; // the intersection, conversion from Set is slow
    // for each item in the shortest array
    for (let i = 0; i < shortest.length; i++) {
        const item = shortest[i];
        // see if item is in every subsequent array
        let every = true; // don't use ordered.every ... it is slow
        for (let j = 1; j < ordered.length; j++) {
            if (ordered[j].includes(item))
                continue;
            every = false;
            break;
        }
        // ignore if not in every other array, or if already captured
        if (!every || set.has(item))
            continue;
        // otherwise, add to bookeeping set and the result
        set.add(item);
        result[result.length] = item;
    }
    return result;
}
exports.fastIntersection = fastIntersection;
function transformMoneyInput(cb) {
    return function (x) {
        let value = Math.round(parseFloat(x) * 100);
        let money = { raw: value };
        if (cb) {
            cb(money);
        }
        ;
        return money;
    };
}
exports.transformMoneyInput = transformMoneyInput;
